// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 46 ? "f0baf142" : chunkId) + "." + {"46":"ae893accf86f038d","81":"a941b5af8c452c8f","641":"517f4ab7266513d2","971":"9460932019f46e3e"}[chunkId] + ".js";
};